"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Normalizes the duration of a transition.
 * @param {number|object} duration The value to normalize.
 * @param {'hide'|'show'} type The type of transition.
 * @returns {number}
 */
var _default = function _default(duration, type) {
  return typeof duration === 'number' || typeof duration === 'string' ? duration : duration[type];
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/lib/normalizeTransitionDuration.js
// module id = 1499
// module chunks = 0